module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 419
// module chunks = 88 89